module.exports = __webpack_public_path__ + "img/TokenizeLA.ff3ab533.png";